export enum ExamFilter {
    Contest = 0,
    Year = 1
}
